import { IGeolocation } from "@/lib/types";

// ---------------------- Service

export class GeolocationService {
  // --------- Methods

  static async getCurrentLocation(): Promise<IGeolocation> {
    const position = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });

    const { latitude, longitude } = position.coords;

    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
    );

    if (!response.ok) throw new Error("Failed to fetch address");

    const data = await response.json();

    return {
      latitude,
      longitude,
      address: {
        display_name: data.display_name,
        house_number: data.address?.house_number,
        road: data.address?.road,
        suburb: data.address?.suburb,
        city: data.address?.city,
        state: data.address?.state,
        postcode: data.address?.postcode,
        country: data.address?.country,
      },
      deviceType: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
    };
  }
}
